<form>
  <div class="modal-body">
    <div class="row">
      <div class="mb-3 text-secondary col-12">
        <small class="form-text">Les champs marqués d'un <em class="text-danger">*</em> sont obligatoires. </small>
      </div>
      <app-dynamic-form
        #supportTypePlaces
        class="col-12"
        title="Places d'accompagnement"
        [data]="structure.supportPlaces"
        [fields]="supportTypePlaceFields"
        [validators]="validators"
        [asyncValidators]="asyncValidators"
        [validatorsMessageTemplate]="validatorsTemplate"
        noGroupText="Vous n'avez aucune place d'accompagnement renseignée. Cliquez sur le bouton + pour en ajouter."
        >
        <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
          <div class="text-secondary col-12 col-lg-5 mb-2" [formGroup]="group">
            <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Type d'accompagnement</label>
            <select
              class="form-select"
              formControlName="supportTypeId"
              [class.is-invalid]="submitted && group.controls?.supportTypeId?.errors?.required"
              >
              <option value=""></option>
              @for (option of supportTypes; track option) {
                <option [ngValue]="option.id">
                  {{ option.label }}
                </option>
              }
            </select>
            @if (submitted && group.controls?.supportTypeId?.errors?.required) {
              <small class="form-text text-danger"
                >Le type d'accompagnement est requis.</small
                >
              }
            </div>
            <div class="text-secondary col-12 col-lg-3 mb-2" [formGroup]="group">
              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">CLI</label>
              <select class="form-select" formControlName="cliId" [class.is-invalid]="submitted && group.controls?.cliId?.errors?.required">
                <option value=""></option>
                @for (cli of clis; track cli) {
                  <option [ngValue]="cli.id">{{ cli.label }}</option>
                }
              </select>
              @if (submitted && group.controls?.cliId?.errors?.required) {
                <small class="form-text text-danger">La CLI est requise.</small>
              }
            </div>
            <div class="text-secondary col-12 col-lg-4 mb-2" [formGroup]="group">
              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Nombre de places</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control me-3"
                  formControlName="placesNumber"
                  [class.is-invalid]="submitted && group.controls?.placesNumber?.invalid"
                  maxlength="5"
                  />
                <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary" (click)="groupRemoved(groupIndex)">
                  <fa-icon icon="trash-alt"></fa-icon>
                </button>
              </div>
              @if (submitted && group.controls?.placesNumber?.errors?.required) {
                <small class="form-text text-danger"
                  >Le nombre de places est requis.</small
                  >
                }
                @if (submitted && group.controls?.placesNumber?.errors?.pattern) {
                  <small class="form-text text-danger"
                    >Le nombre de places doit être supérieur à 0.</small
                    >
                  }
                </div>
              </ng-template>
            </app-dynamic-form>
            <ng-template #validatorsTemplate let-items="items">
              @if (items?.errors?.unavailable) {
                <div class="row mb-2">
                  <div class="col-12">
                    <small class="form-text text-danger">
                      Il est impossible de saisir plusieurs lignes avec la CLI et le type d'accompagnement identiques.
                    </small>
                  </div>
                </div>
              }
            </ng-template>
          </div>
        </div>
      </form>
